import React, {createContext, useState} from 'react';

const UserInfoContext = createContext({});

const UserInfoProvider = ({children, userInfo}) => {
  if (!userInfo) return null;

  const seperatedName = userInfo.fullName.split(' ');
  const [notificationCount,setNotificationCount] = useState(userInfo.unviewedNotificationCount)

  let firstName, lastName = '';
  if (typeof seperatedName[0] !== 'undefined')
    firstName = seperatedName[0];
  if (typeof seperatedName[1] !== 'undefined')
    lastName = seperatedName[1];

  const value = {
    externalUserId: userInfo.externalUserId,
    fullName: userInfo.fullName,
    firstName: firstName,
    lastName: lastName,
    role: userInfo.role,
    email: userInfo.email,
    permissions: userInfo.permissions,
    faOptions: userInfo.faOptions,
    firstTimeLogin: userInfo.firstTimeLogin,
    notificationCount,
    setNotificationCount
  }

  return <UserInfoContext.Provider value={value}>
    {children}
  </UserInfoContext.Provider>
}

export {UserInfoContext, UserInfoProvider}


// WEBPACK FOOTER //
// ./src/providers/UserProvider.js